import { AxiosError } from 'axios';
import useForm from 'antd/es/form/hooks/useForm';
import { AutomaticCheckJournalFormFields } from 'types';
import { commonTexts, journalTexts } from 'consts/text';
import { AppForm, AppFormProps } from '../../../organisms';
import { AutomaticCheckJournalPeriodDatePickerElement, FormNavButtons } from '../../../molecules';
import { AppFormItem } from '../../../atoms';

type AutomaticCheckJournalAddFormProps = Omit<
    AppFormProps<AutomaticCheckJournalFormFields>,
    'width' | 'title' | 'onFinish' | 'error' | 'withGoBack'
> & {
    axiosError?: AxiosError | null;
    isLoading?: boolean;
    onFinish: (consultationData: AutomaticCheckJournalFormFields) => void;
};

export const AutomaticCheckJournalAddForm = ({
    form,
    axiosError,
    ...props
}: AutomaticCheckJournalAddFormProps) => {
    const [formInstance] = useForm<AutomaticCheckJournalFormFields>(form);

    const automaticCheckJournalAddError = axiosError ? commonTexts.errorMessages.unknown : '';

    return (
        <AppForm<AutomaticCheckJournalFormFields>
            form={formInstance}
            title={journalTexts.journalDetails.common.automaticCheckJournal.checkJournal}
            error={automaticCheckJournalAddError}
            withGoBack
            {...props}
        >
            <AppFormItem justifyContent="space-between" doubleItem>
                <AutomaticCheckJournalPeriodDatePickerElement mode="start" />
                <AutomaticCheckJournalPeriodDatePickerElement mode="finish" />
            </AppFormItem>

            <FormNavButtons
                buttonText={journalTexts.journalDetails.common.automaticCheckJournal.checkJournal}
                withPlus
            />
        </AppForm>
    );
};
